import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { Box, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
	NUMBER_CELL_CLASS,
	NUMBER_CELL_ROOMY_CLASS,
	ONE_LINE_CELL_CLASS,
} from "@/controls/ag-grid/OneLineCells";
import type { Barrel } from "../models/Barrel";
import { activeColumnDef } from "@/controls/ag-grid/components/ActiveColumn";

const numberCell = [
	ONE_LINE_CELL_CLASS,
	NUMBER_CELL_CLASS,
	NUMBER_CELL_ROOMY_CLASS,
];

interface UseTableDataProps {
	onDelete: (barrel: Barrel) => void;
}

const formatDiameter = (params: { value: number | null }) =>
	params.value != null ? params.value.toFixed(3) : "";

export const useTableData = ({ onDelete }: UseTableDataProps) => {
	const columnDefs: ColDef<Barrel>[] = [
		{
			field: "Name",
			headerName: "Name",
			flex: 4,
			minWidth: 160,
			sortable: true,
			filter: true,
			tooltipField: "Name",
			cellClass: ONE_LINE_CELL_CLASS,
		},
		{
			field: "StandName",
			headerName: "Stand",
			width: 75,
			sortable: true,
			cellClass: ONE_LINE_CELL_CLASS,
		},
		{
			field: "TopDiameter",
			headerName: "Top Diam",
			width: 95,
			sortable: true,
			cellClass: numberCell,
			valueFormatter: formatDiameter,
		},
		{
			field: "BottomDiameter",
			headerName: "Bottom Diam",
			width: 105,
			sortable: true,
			cellClass: numberCell,
			valueFormatter: formatDiameter,
		},
		activeColumnDef<Barrel>(),
		{
			headerName: "",
			width: 60,
			minWidth: 60,
			maxWidth: 60,
			sortable: false,
			filter: false,
			resizable: false,
			suppressSizeToFit: true,
			cellRenderer: (params: ICellRendererParams<Barrel>) => {
				if (!params.data) return null;
				return (
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
						}}
					>
						<Tooltip title="Delete">
							<IconButton
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									onDelete(params.data as Barrel);
								}}
								color="error"
								sx={{ p: 0.25 }}
							>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];

	return { columnDefs };
};
